<!-- Reaction-vs-TOI inline warning banner (shown at top, outside horizontal scroll container) -->
<div
  *ngIf="SensorsTypes?.length != 0 && reactionToiWarning.visible"
  #reactionToiWrapper
  class="reaction-toi-banner-container inline-warning-sticky"
  [style.height.px]="reactionToiWarning.pinned ? reactionToiWarning.placeholderHeight : null"
>
  <div
    #reactionToiBanner
    class="inline-warning-banner"
    role="alert"
    [class.inline-warning-banner-fixed]="reactionToiWarning.pinned"
    [class.mat-elevation-z4]="reactionToiWarning.pinned"
    [style.top.px]="reactionToiWarning.pinned ? reactionToiWarning.pinnedTop : null"
    [style.left.px]="reactionToiWarning.pinned ? reactionToiWarning.pinnedLeft : null"
    [style.width.px]="reactionToiWarning.pinned ? reactionToiWarning.pinnedWidth : null"
  >
    <div class="inline-warning-icon">
      <mat-icon class="material-icons-outlined">warning</mat-icon>
    </div>
    <div class="inline-warning-text">
      <div class="inline-warning-title">Reaction time vs TOI</div>
      <div class="inline-warning-body">{{ reactionToiWarning.message }}</div>
    </div>
    <button
      type="button"
      class="inline-warning-close"
      (click)="dismissReactionToiWarning()"
      aria-label="Dismiss warning"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="full-width tk-cs-sensor">

      <!-- Tip and cue user picked -->
      <div *ngIf="target?.taskStrategy === 'Tip-and-Cue'" style="padding-left: 9px;">
        <mat-tab-group #tabGroup class="custom-tab-group" (selectedTabChange)="onTabChange($event)">
          <mat-tab label="Select Tipping Sensor"></mat-tab>
          <mat-tab label="Select Cueing Sensor" [disabled]="isCueingTabDisabled()"></mat-tab>
        </mat-tab-group>
      </div>
      <!-- Tip and cue user picked -->

   <div style="font-family: 'Barlow', sans-serif !important;text-align: center; margin-top: unset; font-size: 14px" *ngIf="SensorsTypes?.length == 0 && target?.taskStrategy !== 'Tip-and-Cue'">
    <p>No sensors are meeting the selected intent. Please change the intent and try again.</p>
  </div>
  <div style="font-family: 'Barlow', sans-serif !important;text-align: center; margin-top: unset; font-size: 14px" *ngIf="SensorsTypes?.length == 0 && target?.taskStrategy === 'Tip-and-Cue' && !tipAndCueSensorTypesLoading">
    <p>No sensors are meeting the required criteria. Please change the time of interest (TOI), sensor type, resolution, or the intent and try again.</p>
  </div>
  <div class="content" *ngIf="SensorsTypes?.length > 0">
    <div class="mat-head" style="display: flex;flex-direction: column;">
      <h6 style="font-size: 15px;padding-left: 15px;" *ngIf="!checkTipCue() && SensorsTypes?.length === 0">Loading sensor types...</h6>
      <div *ngIf="!SensorsTypes" style="font-size: 15px;padding-left: 15px;">Loading sensor details...</div>
      <div class="table-check" *ngIf="SensorsTypes">
      <div [ngClass]="!checkTipCue() ? 'table-sensor' : 'table-sensor no-bd'" >
        <h6 style="display: flex;gap:12px; align-items: center;"  *ngIf="!checkTipCue()">Select Sensors
          <span >
              <mat-slide-toggle [(ngModel)]="isAllSensorTypesChecked" (ngModelChange)="onAllSensorTypesChange($event)" class="select-all-toggle" [disabled]="isBulkSensorTypesLoading">
                <span class="cs-lb" style="
                          font-size: 16px;
                          padding-right: 20px;
                          font-weight: 300;
                        ">Select All</span>
              </mat-slide-toggle>
            
          </span>
        </h6>
        <div>
          
          <span *ngFor="let sensor of SensorsTypes; let i = index">
            <span>
              <mat-checkbox [(ngModel)]="sensor.selected" [checked]="sensor.selected"
                (ngModelChange)="onSensorTypeChange(sensor, i)" [disabled]="isBulkSensorTypesLoading || (this.currentUser.pointsEligible && sensor.value === 'AIS')">
                <span style="
                          font-size: 16px;
                          padding-right: 20px;
                          color: #026fc2;
                          font-weight: 300;
                        ">{{ sensor.name }} <img alt="" [src]="tooltipImagePath" style="margin: 0 0 4px 5px;"
                      matTooltip={{sensor.description}}></span>
                </mat-checkbox>
              </span>
            </span>
          </div>

        </div>
        <div *ngIf="target?.taskStrategy != 'Tip-and-Cue'" class="toggle-btns">
          <div class="col">
            <mat-slide-toggle [(ngModel)]="isNightSensor" [disabled]="checkTipCue() || !selectedSensorList.length" (change)=" !isTipAndCue ? toggleNightSensors() : undefined"
              matTooltip="Shows all night vision sensors">Night Imagery</mat-slide-toggle>
            <mat-slide-toggle [(ngModel)]="isDailySubdaily" [disabled]="checkTipCue() || !selectedSensorList.length" (change)=" !isTipAndCue ? toggleDailySubdaily() : undefined"
              matTooltip="Shows all daily/sub-daily revisit sensors">Daily/sub-daily revisit sensors</mat-slide-toggle>
            <mat-slide-toggle [(ngModel)]="isAllSensors" (change)="resetSorting();toggleAll()"
              matTooltip="Shows all sensors including available in near future"
              [disabled]="checkTipCue() || !selectedSensorList.length">Upcoming
              Sensors</mat-slide-toggle>
          </div>
          <div class="col">
            <mat-slide-toggle [(ngModel)]="isOpportunitySensors" (change)="resetSorting(); toggleOpportunitySensors()"
              matTooltip="Shows all opportunity tasking sensors"
              [disabled]="checkTipCue() || !selectedSensorList.length">Opportunity tasking sensors</mat-slide-toggle>
            <mat-slide-toggle [(ngModel)]="isObfuscatedSensors" (change)="resetSorting(); toggleObfuscatedSensors()"
              matTooltip="Shows all obfuscated sensors"
              [disabled]="checkTipCue() || !selectedSensorList.length">Obfuscated sensors</mat-slide-toggle>
          </div>
            
        </div>
      </div>
      <span class="toggle">'x' is the base cost</span>
    </div>
  </div>
</div>

<div class="tab-panels scrollbar" id="scrollcustom" *ngIf="SensorsTypes?.length != 0">
<div class="rows table-checkbox">
  <div *ngIf="isBulkSensorTypesLoading" style="display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
    <span >Loading...</span>
  </div>
  <table class="tasking-cost-table" *ngIf="target.taskStrategy === 'Tip-and-Cue' ? selectedTabIndex === 0 ? tippingSensorTypes.length > 0 : cueingSensorTypes.length > 0 : dataSource?.data.length && !isBulkSensorTypesLoading" mat-table [dataSource]="dataSource" matSort
  (matSortChange)="sortData($event)" class="mat-elevation-z8">
    <ng-container matColumnDef="operator">
      <th mat-header-cell class="table-header-cell" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by operator">
        <span>Sensor Name <img style="margin-left: 4px; margin-top: -2px" width="14px" src="../../../assets/images/union-white.svg" matTooltip="Sensor name with the sensor type" /></span>
      </th>
      <td mat-cell class="cell-Main-Table" *matCellDef="let row; let i = index">
        <span>
          <mat-checkbox (click)="$event.preventDefault(); $event.stopPropagation(); getTotalCost(!row.checked, i, row)"
          [checked]="row.checked"
            [disabled]="!row.enabled || row.prevent ||
            (this.capellaEnable && row.sensor != 'SAR') || (this.satCapeEnable && row.sensor != 'SAR' && row.sensor != 'ScanSAR' && row?.key != OPERATOR.SATELLOGIC && row?.key != OPERATOR.STE && row?.key != OPERATOR.USL && row?.key != OPERATOR.BLACKSKY
            && row?.key != OPERATOR.LBAND && row?.key != OPERATOR.STE_TELEOS  && row?.key != OPERATOR.PIXXEL)">
            <div style="display: flex; align-items: center;">
              <div>
                <span [matTooltip]="row?.sensorDesc">
                  {{ (currentUser?.obfuscated && row.obfuscateName)? row.obfuscateName : row.name }} {{ row.sensor }}</span>
              </div>

                <span style="margin-left: 5px;" *ngIf="row?.cancelPolicy">
                  <img style="margin-left: 3px" width="15px" [src]="tooltipImagePath" [matTooltip]="this.detailsText"
                    matTooltipClass="tooltips" (mouseover)="selections(row)" (mouseout)="onMouseOut()"
                    [matTooltipDisabled]="tooltipDisabled" />
                </span>

                <span style="margin-left: 5px;" *ngIf="isDailySubdaily">
                  <img style="margin-left: 5px" width="17px" [src]="isDailySubdailySensorTooltip"
                    [matTooltip]="'High revisit collection sensor: '+ row?.cadence_value +' revisit(s)'"
                    matTooltipClass="tooltips">
                </span>



                <span style="margin-left: 5px;" *ngIf="(row?.key === OPERATOR.ECURS || row?.key === OPERATOR.ECURS_L) 
             && row?.sensor === 'InSAR'">
                  <img style="margin-left: 2px; margin-top: -1px;" width="26px"
                    src="../../../assets/images/beta-version.png" />
                </span>
              </div>
            </mat-checkbox>
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let row; let i = index" style="padding-left: 0px !important; padding-right: 5px">
          <span *ngIf="row.enabled && row.supportedTarget">
            <mat-icon class="material-icons-outlined map-active" style="cursor: pointer"
              [matTooltip]="row.supportedTarget">
              location_on
            </mat-icon>
          </span>
          <span *ngIf="!row.enabled && row.supportedTarget">
            <mat-icon class="material-icons-outlined map-active" style="color: gray !important;">
              location_on
            </mat-icon>
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

    <ng-container matColumnDef="bandOption">
      <th mat-header-cell class="table-header-cell" *matHeaderCellDef>
        <span>Bands</span>
      </th>
      <td mat-cell class="cell-Main-Table" *matCellDef="let row; let idx = index">
        <mat-select [disableOptionCentering]="true" *ngIf="row?.bandOptions && row?.bandOptions.length > 1"
        [panelClass]="'mat-select-panel-up'" placeholder="{{row?.numberOfBands}}"
          style="width: 90px" (selectionChange)="selectBandOption($event.value, idx, row)">
          <mat-option class="triggers" *ngFor="let item of row.bandOptions" [ngValue]="item"
            [value]="item">
            <div class="d-flex justify-content-between">
              <div style=" font-weight: bold;font-size: 14px;">
                <div class="d-flex justify-content-end">
                  {{ item.no_of_bands }}
                </div>
              </div>
            </div>
          </mat-option>
        </mat-select>
        <span *ngIf="row?.bandOptions && row?.bandOptions.length === 1">
            {{ row.numberOfBands }}
        </span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="band">
      <th mat-header-cell *matHeaderCellDef>
      </th>
      <td mat-cell *matCellDef="let row; let i = index" style="padding-left: 0px !important; padding-right: 5px">
        <span *ngIf="row?.sensorTooltip">
            <mat-icon class="material-icons-outlined map-active hello" style="cursor: default" 
            [matTooltip]="row?.sensorTooltip" [matTooltipClass]="'custom-tooltip'" matTooltipPosition="below">
              graphic_eq
            </mat-icon>
            <!-- <mat-icon *ngIf="row.sensortype === 'SAR'|| row?.key === OPERATOR.CAPELLA"  class="material-icons-outlined map-active"
           style="cursor: pointer;margin-left: 19px;font-size: 17px;" 
           (click)="getBandInfo(row)" matTooltip="Band Informations"
          [matMenuTriggerFor]="tooltipMenu">
          description
         </mat-icon> -->
          <mat-icon *ngIf="row.sensortype === 'HSI'|| row?.key === OPERATOR.STE_TELEOS"  class="material-icons-outlined map-active bandIcon"
           style="cursor: pointer;margin-left: 19px;font-size: 17px;" 
           (click)="getBandInfo(row)" matTooltip="Band Informations" matTooltipPosition="below"
          [matMenuTriggerFor]="tooltipMenu">
          description
         </mat-icon>
            <span class="value-added-caption" 
            *ngIf="row?.informationFeeds.length > 0 && currentUser?.user_plan !== 1" [ngStyle]="{ 'margin-left': isBandIconPresent(row) ? '5px' : '40px' }">
              <img class="feed-icon" src="../../../assets/images/sat-earth.png" (click)="getFeedsData(row)" [matMenuTriggerFor]="tooltipFeed" matTooltip="Feed Availability" matTooltipPosition="below">
            </span>
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="preview">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let row; let i = index" style="padding-left: 0px !important; padding-right: 5px">
          <span *ngIf="row.enabled" (click)="OpenPopup(row)">
            <mat-icon class="material-icons-outlined map-active" style="cursor: pointer" matTooltip="Sample">
              image
            </mat-icon>
          </span>
          <span *ngIf="!row.enabled">
            <mat-icon class="material-icons-outlined map-active" style="color: gray !important;">
              image
            </mat-icon>
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="sattarcking">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let row; let i = index" style="padding-left: 0px !important; padding-right: 5px">
          <span *ngIf="row.enabled">
            <mat-icon class="material-icons-outlined map-active" style="cursor: pointer" (click)="OpenSatTracking(row)"
              matTooltip="Show TLE">
              satellite_alt
            </mat-icon>
          </span>
          <span *ngIf="!row.enabled">
            <mat-icon class="material-icons-outlined map-active" style="color: gray !important;">
              satellite_alt
            </mat-icon>
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>


      <ng-container matColumnDef="mode">
        <th mat-header-cell class="table-header-cell" *matHeaderCellDef>
          <span>Mode/Product <img style="margin-left: 4px; margin-top: -2px" width="14px" src="../../../assets/images/union-white.svg" matTooltip="Sensor imaging mode/ Image product" /></span>
        </th>
        <td mat-cell class="cell-Main-Table" *matCellDef="let row; let idx = index"
          style="text-align: left; padding-right: 5px;">
          <span *ngIf="!shouldHideCollectionMode(row); else oskAoiNoMode">
            <span *ngIf="row.collection_mode?.length === 1 && row?.key != OPERATOR.USL"
              style="width: 90px; padding-left: 3px; padding-right: 5px;">
              <span class="truncate-text"
                [matTooltip]="getProductTooltip(row)?.length > 8 ? getProductTooltip(row) : '' "
                style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: inline-block;"
                [ngStyle]="{
              'max-width': (getTextLength(row.selectedModes[0]?.captureMode, row.selectedModes[0]?.productLevel) > 12) ? '90px' : 'auto'
            }">
                <ng-container *ngIf="row.selectedModes[0]?.isCaptureMode && !row.selectedModes[0]?.isProductLevel">
                  {{ row.selectedModes[0].captureMode }}
                </ng-container>
                <ng-container *ngIf="row.selectedModes[0]?.isProductLevel && !row.selectedModes[0]?.isCaptureMode">
                  {{ row.selectedModes[0].productLevel }}
                  <img *ngIf="row.selectedModes[0]?.productDescription" style="margin-left: 8px;margin-top: -2px;"
                    width="15px" [src]="tooltipImagePath" [matTooltip]="row.selectedModes[0]?.productDescription" />
                </ng-container>
                <ng-container *ngIf="row.selectedModes[0]?.isProductLevel && row.selectedModes[0]?.isCaptureMode">
                  {{ row.selectedModes[0].captureMode }} ({{ row.selectedModes[0].productLevel }})
                </ng-container>
              </span>
              <span style="margin-left: 5px;margin-top: 2px;" *ngIf="row.selectedModes[0]?.tooltip">
                <img style="margin-left: 3px" width="15px" [src]="tooltipImagePath"
                  [matTooltip]="row.selectedModes[0]?.tooltip" />
              </span>
              <mat-icon *ngIf="row.selectedModes[0]?.description" class="material-icons-outlined map-active"
                style="cursor: default;margin-left: 9px;font-size: 17px;"
                [matTooltip]="row.selectedModes[0]?.description">
                description
              </mat-icon>
            </span>


            <mat-select *ngIf="row.collection_mode?.length > 1" [disableOptionCentering]="true" class="mode-selector"
              [panelClass]="row?.collection_mode?.length > 4 ? 'matOptionClass' : row?.collection_mode?.length > 3 ? 'matOptionStyle' : row?.collection_mode?.length > 2 ? 'matOpenmodethreeTable' : row?.collection_mode?.length > 1 ? 'matOpenmodetwoTable' : 'matOpenmodeoneTable'"
              style="width: 60px; padding-left: 1px;" [placeholder]="getPlaceHolder(row, idx)"
              (selectionChange)="modeOption($event.value, idx, row)" [multiple]="row?.modeType"
              [(ngModel)]="row.modeResetValue" [matTooltip]="(row?.selectedMode && row?.selectedMode?.length > 5) ? row?.selectedMode : 
          (getPlaceHolder(row, idx).length > 9) ? getPlaceHolder(row, idx) :''">
              <mat-select-trigger *ngIf="row?.key !== OPERATOR.WEATHEREX || (row.selectedMode && row.selectedMode.length > 0)">{{row.selectedMode}}</mat-select-trigger>
              <mat-option class="triggers" *ngFor="let item of row.collection_mode; let i = index" [ngValue]="item.key"
                [value]="item" [disabled]="(row.prevent && (row?.key != OPERATOR.CAPELLA && row?.key != OPERATOR.GHG)) || (capellaEnable && row.sensor != 'SAR') || (satCapeEnable && row.sensor != 'SAR' && row?.key != OPERATOR.SATELLOGIC && row?.key != OPERATOR.STE && row?.key != OPERATOR.USL && row?.key != OPERATOR.BLACKSKY && row?.key != OPERATOR.STE_TELEOS)
              || (spot && row?.key === OPERATOR.STE && i > 1) || (strip && row?.key === OPERATOR.STE && i < 2)
              || (noOfMonths < 6 && row?.key === OPERATOR.GHG && item.captureMode.includes('annual')) || 
              (noOfWeeks < 2 && row?.key === OPERATOR.GHG && item.captureMode.includes('biweekly'))
              || (target.area === 0 && i > 2 && row?.sensor === 'MSI' && row?.key === OPERATOR.KOMPSAT)
              || (target.area > 0 && i < 3 && row?.sensor === 'MSI' && row?.key === OPERATOR.KOMPSAT) || (row?.key === OPERATOR.GHG && (target?.multiTarget?.length < 3 || (target?.multiTarget?.length >= 3 && multiPointsCoveredArea > 144)) && item.captureMode.includes('Complex'))
              || (row?.key === OPERATOR.GHG && (target?.multiTarget?.length > 2 && multiPointsCoveredArea <= 144) && !item.captureMode.includes('Complex')) ||
              (row?.key === OPERATOR.SATELLOGIC && ((target.area === 0 && item?.captureMode.includes('Area')) ||
              (target.area > 0 && !item?.captureMode.includes('Area'))||
              (this.target.area > 0 && !item?.captureMode.includes('Area')))) || (row?.key === OPERATOR.ISI && row?.sensor === 'Stereo' && item.key === 'Pan-sharpened' && row?.valueAddedOption?.length > 0) 
              || isOperatorModeDisabled(row, item)
              || (row?.key === OPERATOR.ECURS && target.area > 0 && item.key === 'Spotlight (SL)') 
              || (row?.key === OPERATOR.ECURS && target.area === 0 && item.key != 'Spotlight (SL)') || ((row?.key === OPERATOR.SDS || row?.key === OPERATOR.ORBVIEW) && row.sensor !== 'Stereo' && ((target.area === 0 && item?.captureMode.includes('Strip')) ||
              (target.area > 0 && !item?.captureMode.includes('Strip')))) || ((row?.key === OPERATOR.ORBVIEW) && row.sensor === 'Stereo' && !item?.captureMode.includes('Stereo'))">

                <!-- Content remains unchanged for the dropdown -->
                <div class="d-flex justify-content-between" style="font-size: 14px;font-weight: bold;">

                  <span *ngIf="!item?.isCaptureMode && !item?.isProductLevel">{{ item?.name || item?.key }}
                    <img *ngIf="item?.description" style="margin-left: 15px;" width="15px" [src]="tooltipImagePath"
                      [matTooltip]="item?.description" />
                  </span>

                  <span *ngIf="item?.isCaptureMode && !item?.isProductLevel">{{ item?.stripLengthMin != null ? (item.captureMode + ' ' + item.stripLengthMin + '-' + item.stripLengthMax + 'km') : item.captureMode }}
                    <img *ngIf="item?.tooltip" style="margin-left: 15px;" width="15px" [src]="tooltipImagePath"
                      [matTooltip]="item?.tooltip" />
                    <mat-icon *ngIf="item?.description" class="material-icons-outlined map-active"
                      style="cursor: default;margin-left: 9px;font-size: 17px;" [matTooltip]="item?.description">
                      description
                    </mat-icon>
                  </span>

                  <div *ngIf="item?.isProductLevel && !item?.isCaptureMode" style="display: flex;
            width: 50px;
            justify-content: space-between;">
                    <span>{{ item.productLevel }}
                    </span>
                    <img *ngIf="item?.productDescription" style="margin-left: 15px;" width="15px"
                      [src]="tooltipImagePath" [matTooltip]="item?.productDescription" />
                  </div>



                  <div>
                    <span *ngIf="item?.isProductLevel && item?.isCaptureMode">{{ item.captureMode }}
                      <img *ngIf="item?.tooltip" style="margin-left: 2px;" width="15px" [src]="tooltipImagePath"
                        [matTooltip]="item?.tooltip" />
                    </span>
                    <span *ngIf="item?.isProductLevel && item?.isCaptureMode" style="padding-left: 2px;">
                      ({{ item.productLevel }}
                      <img *ngIf="item?.productDescription" style="margin-left: 2px;" width="15px"
                        [src]="tooltipImagePath" [matTooltip]="item?.productDescription" /> )
                    </span>
                    <span style="margin-left: 5px;"
                      *ngIf="row?.key === OPERATOR.UMBRA && (item?.value === '10km x 10km' || item?.value === '10km x 10km(CPHD)')">
                      <img class="mt-10" alt="" [src]="qualitySticker" />
                    </span>
                  </div>
                </div>
              </mat-option>
            </mat-select>
          </span>
          <ng-template #oskAoiNoMode>
            
          </ng-template>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="swath">
        <th mat-header-cell class="table-header-cell" *matHeaderCellDef [hidden]="!showSwath">
          <span style="width: 50px">Swath <img style="margin-left: 4px; margin-top: -2px" width="14px" src="../../../assets/images/union-white.svg" matTooltip="Scene width" /></span>
        </th>
        <td mat-cell class="cell-Main-Table" *matCellDef="let row" [hidden]="!showSwath">
          <span *ngIf="row.selectedModes?.[0]?.swathWidth">
            {{ row.selectedModes[0].swathWidth }} km
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="resolution">
        <th mat-header-cell class="table-header-cell border-class" *matHeaderCellDef mat-sort-header
          sortActionDescription="Sort by resolution" style="width: auto; margin-left: 10px">
          <span style="display: inline-flex; align-items: center; white-space: nowrap;">
            <span [ngStyle]="{'display': 'inline-block', 'text-align': 'left', 'line-height': tripleHeader ? '1.2' : 'normal', 'white-space': tripleHeader ? 'normal' : 'nowrap', 'max-width': tripleHeader ? '220px' : 'none'}">{{columnResolution}}</span>
            <img style="margin-left: 4px; margin-right: 2px; flex-shrink: 0;" width="14px" src="../../../assets/images/union-white.svg" [matTooltip]="resolutionColumnTooltip || 'Spatial or pixel resolution'" />
          </span>
        </th>
        <td mat-cell class="cell-Main-Table border-style" *matCellDef="let row; let idx = index"
          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-left: 10px">
          <span *ngIf="row.updateFrequency">
            {{row.updateFrequency}}
          </span>

          <!-- WeatherEx: Grid + Temporal resolution dropdowns side by side -->
          <div *ngIf="row?.key === OPERATOR.WEATHEREX" style="display: flex; flex-direction: row; gap: 8px; align-items: flex-start;">
            <mat-select *ngIf="target?.area !== 0" [disableOptionCentering]="true"
              [panelClass]="row?.resolution?.length > 3 ? 'matOpenResFourTable' : row?.resolution?.length > 2 ? 'matOpenResThreeTable' : 'matOpenResTwoTable'"
              style="width: 90px; white-space: nowrap;"
              (selectionChange)="resolutionChange($event.value, idx, row)"
              [placeholder]="row?.selectedResolutionValue ? getResolutionLabel(row.selectedResolutionValue) : getResolutionLabel(row?.resolution?.[0]?.value)"
              [(ngModel)]="row.selectedResolutionData">
              <mat-select-trigger style="font-size: 14px;">{{ getResolutionLabel(row?.selectedResolutionValue) }}</mat-select-trigger>
              <mat-option *ngFor="let item of row.resolution" [value]="item">{{ item.value }}</mat-option>
            </mat-select>
            <mat-select [disableOptionCentering]="true" panelClass="matOpenmodetwoTable"
              style="width: 90px; white-space: nowrap;"
              [(ngModel)]="row.selectedRefreshRate"
              (selectionChange)="refreshRateChange($event.value, idx, row)"
              [placeholder]="row.selectedRefreshRate?.value ?? row.refreshRates?.[0]?.value">
              <mat-select-trigger style="font-size: 14px;">{{ row.selectedRefreshRate?.value }}</mat-select-trigger>
              <mat-option *ngFor="let rate of row.refreshRates" [value]="rate">{{ rate.value }}</mat-option>
            </mat-select>
          </div>

          <!-- All other sensors: existing resolution content -->
          <ng-container *ngIf="row?.key !== OPERATOR.WEATHEREX">
          <span *ngIf="row?.resolution?.length === 1 || row?.rf_services?.length === 1">
            {{ row?.resolution?.length === 1 ? getResolutionLabel(row?.resolution[0].value) :
            getResolutionLabel(row?.rf_services[0].value) }}
            <img
              *ngIf="(row?.resolution?.length === 1 && (row?.resolution[0]?.mode_value || row?.resolution[0]?.value?.includes(':'))) || 
              (row?.rf_services?.length === 1 && (row?.rf_services[0]?.mode_value || row?.rf_services[0]?.value?.includes(':')))"
              style="margin-left: 5px;padding-top: 1px;" width="15px" [src]="tooltipImagePath"
              [matTooltip]="row?.resolution?.length === 1 ? row?.resolution[0]?.value : row?.rf_services[0]?.value" />
          </span>

          <div style="position: relative; display: inline-block; width: 90px;">
            <mat-select [disableOptionCentering]="true"
              [matTooltip]="getResolutionLabel(row?.selectedResolution?.value).length > 10 ? row?.selectedResolution?.value : ''"
              [panelClass]="row?.resolution?.length > 3 ? 'matOpenResFourTable' : row?.resolution?.length > 2 ? 'matOpenResThreeTable' : 'matOpenResTwoTable'"
              *ngIf="(row?.resolution?.length > 1) || (row?.rf_services?.length > 1)"
              style="width: 90px; white-space: nowrap;" (selectionChange)="resolutionChange($event.value, idx, row)"
              placeholder="{{row?.selectedResolutionValue ?  getResolutionLabel(row?.selectedResolutionValue) : row?.selectedResolution ? getResolutionLabel(row?.selectedResolution.value) : getResolutionLabel((row?.resolution?.[0]?.value || row?.rf_services?.[0]?.value)) }}"
              [(ngModel)]="row.selectedResolutionData">

              <mat-select-trigger style="font-size: 14px; white-space: nowrap; display: flex; align-items: center;">
                {{ getResolutionLabel(row?.selectedResolutionValue) }}
              </mat-select-trigger>

              <mat-option class="triggers" *ngFor="let item of (row?.resolution || row?.rf_services)"
                [ngValue]="item.value" [selected]="(row?.resolution || row?.rf_services) === item.value" [value]="item"
                [disabled]="shouldDisableResolution(item,row,idx)"
                [ngClass]="{ 'disableOptionResolution': shouldDisableResolution(item,row,idx)}">
                <div class="d-flex justify-content-between" style="white-space: nowrap;">
                  <div style=" font-weight: bold;font-size: 14px;">
                    <div class="d-flex justify-content-end">
                      {{ item.value }}
                      <span>
                        <img *ngIf="item?.mode_value" style="margin-left: 10px; padding-top: 18px;" width="15px"
                          [src]="tooltipImagePath" [matTooltip]="item?.mode_value" />
                      </span>
                    </div>
                  </div>
                  <div style="text-align: right;" *ngIf="row?.key === OPERATOR.AXELSPACE || 
              row?.key === OPERATOR.AT21">
                    {{ item?.multiplier }}x
                  </div>
                </div>
              </mat-option>
            </mat-select>

            <!-- Absolute-positioned tooltip icon -->
            <img *ngIf="row?.selectedResolution?.value?.includes(':') && row.resolution?.length > 1"
              style="position: absolute; top: 50%; transform: translateY(-50%); right: 30px; cursor: pointer;"
              width="15px" [src]="tooltipImagePath" [matTooltip]="row?.selectedResolution?.value" />
          </div>
          </ng-container>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="looks" *ngIf="showLooks">
        <th mat-header-cell class="table-header-cell" *matHeaderCellDef>
          <span>Looks <img style="margin-left: 4px; margin-top: -2px" width="14px" src="../../../assets/images/union-white.svg" matTooltip="An independent sub-image intended to remove noise from the whole image, making it sharper" /></span>
        </th>
        <td mat-cell class="cell-Main-Table" *matCellDef="let row; let idx = index">
          <mat-select [disableOptionCentering]="true" *ngIf="row?.selectedResolution?.numberOfLooks"
            [panelClass]="'mat-select-panel-up'" [(ngModel)]="row.selectedLooks" style="width: 90px"
            (selectionChange)="looksChange($event.value, idx, row)"
            placeholder="{{row?.selectedLooksValue ? row.selectedLooksValue : row.selectedResolution.numberOfLooks[0]}}">
            <mat-option class="triggers" *ngFor="let item of row.selectedResolution.numberOfLooks" [ngValue]="item"
              [value]="item"
              [disabled]="(row?.selectedResolutionValue === '1m' && row.selectedModes[0].value === 'SAR Video' && item != 'x5')">
              <div class="d-flex justify-content-between">
                <div style=" font-weight: bold;font-size: 14px;">
                  <div class="d-flex justify-content-end">
                    {{ item }}
                  </div>
                </div>
              </div>
            </mat-option>
          </mat-select>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="signalOfInterest" *ngIf="lband">
        <th mat-header-cell class="table-header-cell" *matHeaderCellDef>
          <span style="width: 115px;">Signal of Interest <img style="margin-left: 4px; margin-top: -2px" width="14px" src="../../../assets/images/union-white.svg" matTooltip="Which RF product?" /></span>
        </th>
        <td mat-cell class="cell-Main-Table" *matCellDef="let row; let idx = index">
          <span *ngIf="
                row.signal_of_interest?.length === 1 && row?.key === OPERATOR.USL
              " style="width: 90px; padding-left: 3px; padding-right: 5px">
            <ng-container *ngFor="
                  let detail of row.signal_of_interest[0]?.key.split(',');
                  let last = last
                ">
              <span class="truncate-text" style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  ">{{ detail.trim() }}
              </span>
              <ng-container *ngIf="!last">,</ng-container>
              <br *ngIf="!last" />
            </ng-container>
            <span style="margin-left: 5px" *ngIf="row.signal_of_interest[0]?.tooltip">
              <img style="margin-left: 3px" width="15px" [src]="tooltipImagePath"
                [matTooltip]="row.signal_of_interest[0]?.tooltip" />
            </span>
          </span>
          <mat-select *ngIf="row?.signal_of_interest && row?.key !== OPERATOR.USL " multiple
            [disableOptionCentering]="true" #mySelects [panelClass]="'matOpenDatafourTable'"
            (selectionChange)="signalChange($event, idx,mySelects)"
            [placeholder]="row?.signalOfInterest?.length > 0 ? row?.selectedSignals : 'Select Signals'"
            [ngClass]="row?.signalOfInterest?.length > 0 ? 'placeholder-color-active' : ''"
            [value]="row?.signalOfInterest" (openedChange)="onOpenedChange($event)">
            <mat-select-trigger>{{
              row?.selectedSignals ? row?.selectedSignals : 'Select Signals'
              }}</mat-select-trigger>
            <mat-optgroup>
              <!-- Header row with column names -->
              <div class="mat-optgroup-header">
                <span class="column signal-column">Signals</span>
                <span class="column duration-column">Collection Duration</span>
                <span class="column audio-column">Audio</span>
              </div>

              <!-- Data rows -->
              <mat-option *ngFor="let item of row.signal_of_interest; let i = index" [value]="item"
                style="width: 100%;font-size: 14px;font-family: 'Barlow' !important;" [disabled]="row.prevent">
                <div class="tasking-list-menu"
                  style="display: flex; justify-content: space-between; align-items: center;"
                  (click)="$event.stopPropagation()">

                  <!-- Signal Column -->
                  <span class="column signal-column">
                    {{ item.value }}
                    <img *ngIf="item?.frequency" [src]="tooltipImagePath" [matTooltip]="item?.frequency"
                      style="cursor: pointer; margin-left: 8px" width="15px" />
                  </span>

                  <!-- Collection Duration Column -->
                  <mat-select *ngIf="item.collection_duration && !item.isAudio && item.collectionDuration != 60"
                    placeholder="{{item.collectionDuration ? item.collectionDuration : item.collection_duration[0].value}} secs"
                    class="column duration-column" (click)="isDurationChanging = true" [disabled]="row.prevent"
                    (selectionChange)="collectionChange($event, i, item, row)">
                    <mat-option *ngFor="let duration of item.collection_duration" [value]="duration"
                      [ngClass]="{'highlighted-option': duration.value === item.collectionDuration}">{{ duration.value
                      }} secs
                    </mat-option>
                  </mat-select>

                  <div *ngIf="item.isAudio || item.collectionDuration === 60" class="single-value duration-column">{{
                    item.collectionDuration }} secs</div>

                  <!-- Audio Column with checkbox -->
                  <div class="column audio-column" style="display: flex; align-items: center;">
                    <mat-checkbox *ngIf="item?.audioCost" (change)="audioChange($event, item, idx,row)"
                      [disabled]="isAudioSelectionDisabled(item, row)" [checked]="item.collectionDuration === 60"></mat-checkbox>
                    <img *ngIf="item?.audioCost" [src]="tooltipImagePath"
                      [matTooltip]="getAudioTooltip(item)"
                      style="cursor: pointer; margin-left: 8px;" width="15px" />
                  </div>

                </div>
              </mat-option>

              <!-- close Button -->
              <mat-option class="no-checkbox vadp-dropdown-option sticky-option"
                *ngIf="row?.signal_of_interest?.length > 0">
                <div class="option-content">
                  <button mat-stroked-button class="dropdown-button small-button"
                    [ngClass]="{'dropdown-ok-button': row?.signalOfInterest?.length > 0}"
                    (click)="row?.signalOfInterest?.length > 0 ? goNext(mySelects,$event, idx, row) : close(mySelects,$event);">
                    <ng-container *ngIf="row?.signalOfInterest?.length > 0; else dropDownButton">
                      <span>Ok</span>
                    </ng-container>

                    <ng-template #dropDownButton>
                      <span>Close</span>
                    </ng-template>
                  </button>
                </div>
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="unitcost">
        <th mat-header-cell class="table-header-cell" *matHeaderCellDef>
          <span>
            <span>
              Tasking Tier
              <img style="margin-left: 4px; margin-top: -2px" width="14px" src="../../../assets/images/union-white.svg" [matTooltip]="taskTierPref === 'high' ? 'Tasking priorities—fastest to the slowest' : 'Tasking priorities—slowest to the fastest'" />
            </span>
            <mat-icon style="font-size: 16px;margin-top: 1px;margin-left: 2px;"
              matTooltip="Click to select Tasking Tier preference" #iconTooltip="matTooltip"
              (click)="menuTrigger.openMenu()" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">sort</mat-icon>
          </span>
          <mat-menu #menu="matMenu" panelClass="custom-menu">
            <mat-radio-group [(ngModel)]="taskTierPref" (change)="onDropdownChange($event)" class="radio-group">
              <mat-radio-button value="high" class="custom-radio">Fastest to the slowest</mat-radio-button>
              <mat-radio-button value="low" class="custom-radio">Slowest to the fastest</mat-radio-button>
            </mat-radio-group>
          </mat-menu>
        </th>

        <td mat-cell class="cell-Main-Table" *matCellDef="let row; let idx = index">
          <div *ngIf="row.enabled && row.latency" id="costOption" aria-label="Select an option"
            style="max-width: 110px;">
            <mat-select [disableOptionCentering]="true" style="text-transform: capitalize;" #mySelect
              [panelClass]="[
                row.latency.length > 4 ? 'matOpenDatafourTable' : row.latency.length > 3 ? 'matOpenDataFiveTable' : row.latency.length > 2 ? 'matOpenDatathreeTable' : 'matOpenDataoneTable',
                row?.key === OPERATOR.GEOSAT ? 'matOpenDataGeosat' : ''
              ]"
              [placeholder]="row.selectedLatency" [(ngModel)]="row.selectedTaskingTierPrefrence"
              (selectionChange)="taskingTierChange($event.value, row, idx)"
              [matTooltip]="(row?.selectedLatency).length > 10 ? row?.selectedLatency : ''">
              <mat-select-trigger [ngClass]="{
              'mat-select-placeholder': !row.isUserSelection }">
                {{ row.selectedLatency | titlecase }}
              </mat-select-trigger>

              <mat-optgroup>
                <div class="mat-optgroup-cell" [class.geosat-tasking-layout]="row?.key === OPERATOR.GEOSAT">
                  <span>Tasking tier</span>
                  <span>Reaction time
                    <img width="15px" [src]="tooltipImagePath"
                      matTooltip="The latest time to schedule a task request before the overpass" />
                  </span>
                  <span>Response time
                    <img width="15px" [src]="tooltipImagePath"
                      matTooltip=" Time from collection by satellite(s) to delivery" />
                  </span>
                  <span *ngIf="row?.key === OPERATOR.GEOSAT" class="geosat-tasking-cost-header" [hidden]="cpcAndAllocated">Tasking Window Cost
                    <img width="15px" [src]="tooltipImagePath"
                      [matTooltip]="geosatTaskingWindowCostTooltip" matTooltipClass="custom-header-tooltip" />
                  </span>
                  <span class="unit-cost-header" [class.geosat-tasking-cost-header]="row?.key === OPERATOR.GEOSAT" [hidden]="cpcAndAllocated">Unit Cost</span>
                </div>
                <mat-option *ngFor="let elem of row.latency; let i = index" [ngValue]="elem.name"
                  [selected]="(elem.cost || 0) === row.taskcost && !shouldDisableTier(elem, row)" [value]="elem.name"
                  style="width: 100%;" [disabled]="shouldDisableTier(elem,row)"
                  (click)="!shouldDisableTier(elem, row) && taskingOption(elem.name, idx, row, 0, true)">
                  <div class="tasking-list-menu" [class.geosat-tasking-layout]="row?.key === OPERATOR.GEOSAT">
                    <span class="standards">{{ elem.name | titlecase }}
                      <img *ngIf="row?.key === OPERATOR.AT21 && elem?.collectionWindow"
                        style="margin-left: 2px;padding-top: 3px;" width="15px" [src]="tooltipImagePath"
                        [matTooltip]="'Collection window: ' + elem.collectionWindow" />
                      <img *ngIf="row?.key === OPERATOR.SATELLOGIC" style="margin-left: 2px;padding-top: 3px;"
                        width="15px" [src]="tooltipImagePath"
                        [matTooltip]="(elem?.key === 'rush' || elem?.key === 'emergency') ? 'The product delivered is L1B (Geocorrected) over land and water. Additionally, L1D (orthorectified) is delivered over land captures after 10 hrs.' : 'The product delivered is L1D (orthorectified). '" />
                      <img *ngIf="row?.key === OPERATOR.SATVU && elem?.key === 'monitoring'"
                        style="margin-left: 2px;padding-top: 3px;" width="15px" [src]="tooltipImagePath"
                        [matTooltip]="'This is 5 scenes at 650/scene'" />

                    </span>
                    <span class="latency window-align"
                      [matTooltip]="elem?.taskingwindow?.length > 12 ? elem?.taskingwindow : ''">{{elem?.taskingwindow}}
                      <img *ngIf="row?.key === OPERATOR.GEOSAT && elem?.reactionUpliftCost != null"
                        width="15px" [src]="tooltipImagePath"
                        [matTooltip]="'Reaction uplift cost: ' + (elem?.reactionUpliftCost | currencyFormat)" />
                    </span>
                    <span class="latency" *ngIf="(elem.cost || 0) != 0.00">
                      <span *ngIf="elem?.latency"> {{elem?.mode }}</span>
                      {{ elem?.latency }}
                      <img *ngIf="row?.key === OPERATOR.GEOSAT && elem?.responseUpliftCost != null"
                        width="15px" [src]="tooltipImagePath"
                        [matTooltip]="'Response uplift cost: ' + (elem?.responseUpliftCost | currencyFormat)" />
                    </span>
                    <span class="latency" *ngIf="(elem.cost || 0) == 0.00 && !(row?.key === OPERATOR.WEATHEREX && row.quoteLoading)">
                      {{ row?.key === OPERATOR.SENTINEL ? 'N/A' : 'Not Offered' }}
                    </span>
                    <span class="latency" *ngIf="(elem.cost || 0) == 0.00 && row?.key === OPERATOR.WEATHEREX && row.quoteLoading" style="color: #888; font-style: italic;">Fetching…</span>
                    <span *ngIf="row?.key === OPERATOR.GEOSAT && !currentUser.pointsEligible" class="currency geosat-tasking-cost-cell"
                      style="font-size: 14px !important;" [hidden]="cpcAndAllocated">{{ elem.taskingWindowCost || 0 | currencyFormat }}</span>
                    <span *ngIf="row?.key === OPERATOR.GEOSAT && currentUser.pointsEligible" class="currency geosat-tasking-cost-cell"
                      style="font-size: 14px !important;" [hidden]="cpcAndAllocated">{{ convertCostToPoints(elem.taskingWindowCost || 0) }}</span>
                    <span *ngIf="!currentUser.pointsEligible" class="currency unit-cost-cell"
                      [class.geosat-tasking-cost-cell]="row?.key === OPERATOR.GEOSAT"
                      style="font-size: 14px !important;" [hidden]="cpcAndAllocated || (row?.key === OPERATOR.WEATHEREX && row.quoteLoading)">{{ (row.name === "BRO" && target.subDailyCount > 1 && !isUslBroValidated ? (target.subDailyCount * elem.cost) : elem.cost || 0) | currencyFormat }}</span>
                    <span *ngIf="currentUser.pointsEligible" class="currency unit-cost-cell"
                      [class.geosat-tasking-cost-cell]="row?.key === OPERATOR.GEOSAT"
                      style="font-size: 14px !important;" [hidden]="cpcAndAllocated || (row?.key === OPERATOR.WEATHEREX && row.quoteLoading)">{{
                      convertCostToPoints(elem.cost * (row.name === "BRO" && target.subDailyCount > 1 && !isUslBroValidated ? target.subDailyCount : 1) || 0) }}</span>
                  </div>
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="holdback" *ngIf="!lbandOnly">
        <th mat-header-cell class="table-header-cell" *matHeaderCellDef>
          <span>Hold Back <img style="margin-left: 4px; margin-top: -2px" width="14px" src="../../../assets/images/union-white.svg" matTooltip="The time a satellite operator takes to include a tasked image in the archive for access to other customers" /></span>
        </th>
        <td mat-cell class="cell-Main-Table" *matCellDef="let row; let idx = index"
          style="text-align: left; padding-right: 5px">
          <mat-select [disableOptionCentering]="true"
            [panelClass]="row.holdback.length > 3 ? 'matOpenholefourTable' : row.holdback.length > 2 ? 'matOpenholethreeTable' :'matOpenholetwoTable'"
            style="overflow: inherit;" *ngIf="row.holdback?.length > 0" style="width: 74px"
            placeholder="{{row.selectedHoldBack}}" (selectionChange)="holdBackOption($event.value, idx, row)"
            [(ngModel)]="row.holdBackValue">
            <mat-select-trigger [matTooltip]="row?.selectedHoldBack">{{ row.selectedHoldBack }}</mat-select-trigger>
            <mat-option class="triggers" *ngFor="let item of row.holdback; let i = index" [ngValue]="item.key"
              [selected]="row.holdback === item.key" [value]="item"
              [disabled]="(currentUser.allocated && row.selectedHoldBack !== item.key) || (i > 0 && row?.key === OPERATOR.SATELLOGIC) || row.prevent || (this.capellaEnable && row.sensor != 'SAR') || (this.satCapeEnable && row.sensor != 'SAR' && row?.key != OPERATOR.SATELLOGIC && row?.key != OPERATOR.STE 
            && row?.key != OPERATOR.USL && row?.key != OPERATOR.BLACKSKY) || (row?.key === OPERATOR.WYVERN && item.type != row.selectedLatencyKey.key)">
              <div class="d-flex justify-content-between">
                <div style=" font-weight: bold;">
                  <div class="d-flex justify-content-end">
                    {{ item.key }}
                  </div>
                </div>
                <div style=" text-align: right;">
                  {{ item.value }}x
                </div>

              </div>
            </mat-option>
          </mat-select>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

    <ng-container matColumnDef="area_calculated">
      <th mat-header-cell class="table-header-cell" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by area_calculated">
        <span matTooltip="Minimum collection area payable.           The first number in the scene size indicates the swath width."
        matTooltipClass="custom-header-tooltip">Min. Collection <img style="margin-left: 4px; margin-top: -2px" width="14px" src="../../../assets/images/union-white.svg" /></span>
      </th>
      <td mat-cell class="cell-Main-Table" *matCellDef="let row; let idx = index">
        <div class="flex" style="width: 130px;">
          <span *ngIf="row.enabled && row?.minarea">
            <span *ngIf="(row?.sensor != 'Video' && row?.sensor != 'InSAR') && !(row?.sensor === 'Stereo' && row.name === 'KOMPSAT-5')">{{ row.minarea }} {{ row?.collectionunit ? row.collectionunit : row.unit }}</span>
            <span *ngIf="row?.sensor === 'Video' || row?.sensor === 'InSAR' || (row?.sensor === 'Stereo' && row.name === 'KOMPSAT-5')">{{ row.unit }}</span>
            <span *ngIf="row?.tooltipValue">
              <img style="margin-left: 3px" width="15px" [src]="tooltipImagePath"
                [matTooltip]="row?.key === OPERATOR.ORBVIEW && row?.sensor === 'Stereo' && row?.collection_mode?.[0]?.minTooltip
                  ? row?.collection_mode?.[0]?.minTooltip?.[target.area === 0 ? 'POI' : 'AOI']
                  : (row?.key === OPERATOR.AZISTA && tooltipminLength && tooltipminLength.trim() !== '' ? tooltipminLength : row.tooltipValue)"
                  matTooltipPosition="below" alt="tooltip" /></span>
            </span>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="dem">
        <th mat-header-cell class="table-header-cell" *matHeaderCellDef>
          <span>Value Added Data Products <img style="margin-left: 4px; margin-right: 4px; flex-shrink: 0;" width="14px" src="../../../assets/images/union-white.svg" matTooltip="Value Added Data Products" /></span>
        </th>
        <td mat-cell class="cell-Main-Table" *matCellDef="let row; let idx = index">
          <mat-select #vadpselect class="custom-checkbox" multiple *ngIf="(((row.sensor === 'Stereo' || row.sensor === 'Tristereo' || row.sensor === 'TIR') && target.selectedOption !== 1) || (row.sensor === 'MSI'|| row.sensor === 'HSI' )) && 
          row?.valAddedArray?.length > 0" placeholder="Select Products" [disabled]="isValueAddedDisabled(row)" [ngClass]="{
            'reduced-opacity': 
            isValueAddedDisabled(row) ||
            row?.valueAddedAction.length === 0 && row?.superResolutions?.length === 0 && row?.indicesArray?.length === 0 || 
            (row?.superResolutions?.length > 0 && target.selectedOption === 1)
          }" [value]="getSelectedVadp(row)" (selectionChange)="onSelectionChange($event, row, idx)"
            [matTooltip]="displayVadpSelectTooltip(row)" panelClass="vadp-mat-select-position-top">
            <mat-select-trigger style="font-weight: 300;" [matTooltip]="formatGroupedDemTooltip(row.vadp)">
              <span [ngClass]="formatGroupedDem(row.vadp) ? '' : 'format-vadp'">{{ formatGroupedDem(row.vadp) || 'Select
                Products'}}</span>
            </mat-select-trigger>

            <!-- DxM Checkbox Option -->
            <mat-option value="DxM" *ngIf="row?.valueAddedAction?.length > 0 && target.selectedOption !== 1 && hasElevationModelOption(row)"
              (click)="onDxMCheckboxChange(row, idx, 'DxM')" class="value-added-option no-checkbox">
              <div class="option-content">
                <span class="value-added-caption">Elevation Model</span>
                <mat-icon class="arrow-icon" *ngIf="!row.isDxMSelected">keyboard_arrow_down</mat-icon>
                <mat-icon class="arrow-icon" *ngIf="row.isDxMSelected">keyboard_arrow_up</mat-icon>
              </div>
            </mat-option>
            <mat-option disabled class="heading-option sticky-header"
              *ngIf="row?.valueAddedAction?.length > 0 && row.isDxMSelected && target.selectedOption !== 1">
              <div class="option-row header head-flex justify-content-between">
                <div class="header-item resolution">Resolution</div>
                <div class="header-item delivery-time">Delivery Time
                  <img style="margin-left: 7px" width="15px" [src]="tooltipImagePath"
                    matTooltip="The time between the delivery of satellite data and the value-added product." />
                </div>
                <div class="header-item cost-points">
                  <span *ngIf="currentUser?.pointsEligible">Points
                    <img style="margin-left: 7px" width="15px" [src]="tooltipImagePath"
                      matTooltip="The cost per sqkm will be reflected in the unit cost." />
                  </span>
                  <span *ngIf="!currentUser?.pointsEligible">Cost
                    <img style="margin-left: 7px" width="15px" [src]="tooltipImagePath"
                      matTooltip="The cost per sqkm will be reflected in the unit cost." />
                  </span>
                </div>
              </div>
            </mat-option>
            <ng-container *ngIf="row?.valueAddedAction?.length > 0 && row.isDxMSelected && target.selectedOption !== 1">
              <ng-container *ngFor="let group of row?.valueAddedAction; let i = index">
                <!-- Option groups -->
                <mat-optgroup class="custom-option-group" [label]="group.actionProvider">
                  <mat-option class="no-active" *ngFor="let dem_item of group.items;let k = index" [value]="dem_item"
                    (click)="selectDxMOption(dem_item, row, group, idx)" [disabled]="!row.isDxMSelected || row.prevent">
                    <div class="option-row head-flex justify-content-between">
                      <div class="item-content resolution">
                        <span class="custom-standards">{{ dem_item.providerResolution }}</span>
                      </div>
                      <div class="item-content delivery-time" style="padding-left: 0;">
                        <span class="custom-currency">{{ dem_item?.deliveryTime }}hrs</span>
                      </div>
                      <div class="item-content cost-points">
                        <span class="custom-currency" *ngIf="currentUser?.pointsEligible">
                          {{ dem_item?.point || 0 }} points
                        </span>
                        <span class="custom-currency" *ngIf="!currentUser?.pointsEligible">
                          {{ dem_item.cost | currencyFormat }}
                        </span>
                      </div>
                    </div>
                  </mat-option>
                </mat-optgroup>
              </ng-container>
            </ng-container>

            <!-- SR Checkbox and Option Group -->
            <mat-option value="SR" *ngIf="row?.superResolutions?.length > 0 && target.selectedOption !== 1"
              (click)="onSRCheckboxChange(row, idx, 'SR')" class="value-added-option no-checkbox">
              <div class="option-content">
                <span class="value-added-caption">Super Resolution</span>
                <mat-icon class="arrow-icon" *ngIf="!row.isSRSelected">keyboard_arrow_down</mat-icon>
                <mat-icon class="arrow-icon" *ngIf="row.isSRSelected">keyboard_arrow_up</mat-icon>
              </div>
            </mat-option>
            <mat-option disabled class="heading-option sticky-header"
              *ngIf="row?.superResolutions?.length > 0 && row.isSRSelected">
              <div class="option-row header head-flex justify-content-between">
                <div class="header-item resolution">Resolution</div>
                <div class="header-item delivery-time">Delivery Time
                  <img style="margin-left: 7px" width="15px" [src]="tooltipImagePath"
                    matTooltip="The time between the delivery of satellite data and the value-added product." />
                </div>
                <div class="header-item cost-points">
                  <span *ngIf="currentUser?.pointsEligible">Points
                    <img style="margin-left: 7px" width="15px" [src]="tooltipImagePath"
                      matTooltip="The cost per sqkm will be reflected in the unit cost." />
                  </span>
                  <span *ngIf="!currentUser?.pointsEligible">Cost
                    <img style="margin-left: 7px" width="15px" [src]="tooltipImagePath"
                      matTooltip="The cost per sqkm will be reflected in the unit cost." />
                  </span>
                </div>
              </div>
            </mat-option>
            <ng-container *ngIf="row?.superResolutions?.length > 0 && row.isSRSelected">
              <mat-option *ngFor="let resolution of row?.superResolutions; let j = index" class="no-active"
                [value]="resolution" [disabled]="!row.isSRSelected || row.prevent"
                (click)="selectSROption(resolution, row, idx)">
                <div class="option-row head-flex justify-content-between">
                  <div class="item-content resolution">
                    <span class="custom-standards">{{ resolution.providerResolution }}</span>
                  </div>
                  <div class="item-content delivery-time" style="padding-left: 0;">
                    <span class="custom-currency">{{ resolution?.deliveryTime }}hrs</span>
                  </div>
                  <div class="item-content cost-points">
                    <span class="custom-currency" *ngIf="currentUser?.pointsEligible">
                      {{ resolution?.point || 0 }} points
                    </span>
                    <span class="custom-currency" *ngIf="!currentUser?.pointsEligible">
                      {{ resolution.cost | currencyFormat }}
                    </span>
                  </div>
                </div>
              </mat-option>
            </ng-container>

            <!-- Indices Checkbox and Option Group -->
            <mat-option value="Indices" *ngIf="row?.indicesArray?.length > 0"
              (click)="onIndicesCheckboxChange(row, idx, 'Indices')" class="value-added-option no-checkbox">
              <div class="option-content">
                <span class="value-added-caption">
                  Indices
                </span>
                <mat-icon class="arrow-icon" *ngIf="!row.isIndicesSelected">keyboard_arrow_down</mat-icon>
                <mat-icon class="arrow-icon" *ngIf="row.isIndicesSelected">keyboard_arrow_up</mat-icon>
              </div>
            </mat-option>
              <ng-container *ngIf="getEnabledIndicesArray(row).length > 0 && row.isIndicesSelected">
              <mat-option disabled class="heading-option sticky-header">
                <div class="option-row header head-flex justify-content-between">
                  <div class="header-item resolution">Product</div>
                  <div class="header-item delivery-time"></div>
                  <div class="header-item cost-points">
                    <span *ngIf="currentUser?.pointsEligible">Points
                      <img style="margin-left: 7px" width="15px" [src]="tooltipImagePath"
                        matTooltip="The cost is for all the scenes in a single task and will be added when finalising payment." />
                    </span>
                    <span *ngIf="!currentUser?.pointsEligible">Cost
                      <img style="margin-left: 7px" width="15px" [src]="tooltipImagePath"
                        matTooltip="The cost is for all the scenes in a single task and will be added when finalising payment." />
                    </span>
                  </div>
                </div>
              </mat-option>
              <mat-option *ngFor="let indices of getEnabledIndicesArray(row); let j = index" class="no-active" [value]="indices"
                (click)="selectIndicesOption(indices, row, idx)">
                <div class="option-row head-flex justify-content-between">
                  <div class="item-content resolution" class="truncated-option" style="display: flex;">
                    <span class="custom-standards">
                      {{ indices.actionProvider.length > 10 ? (indices.actionProvider | slice:0:10) + '...' :
                      indices.actionProvider }}
                    </span>
                    <img *ngIf="indices.english_word" style="margin-left: 4px; margin-top: -1px" width="14px"
                      [src]="tooltipImagePath" [matTooltip]="indices.english_word" />

                  </div>
                  <div class="item-content delivery-time">
                    <!-- <span class="custom-currency" style="padding-left: 10px;">{{ indices?.deliveryTime }}hrs</span> -->
                  </div>
                  <div class="item-content cost-points">
                    <span class="custom-currency" *ngIf="currentUser?.pointsEligible">
                      {{ indices?.point || 0 }} points
                    </span>
                    <span class="custom-currency" *ngIf="!currentUser?.pointsEligible">
                      {{ indices.cost | currencyFormat }}
                    </span>
                  </div>
                </div>
              </mat-option>
            </ng-container>

            <!-- close Button -->
            <mat-option value="DxM" class="no-checkbox vadp-dropdown-option sticky-option"
              *ngIf="row?.valueAddedAction?.length > 0 || row?.indicesArray?.length > 0 || (row?.superResolutions?.length > 0 && target.selectedOption !== 1)">
              <div class="option-content">
                <button mat-stroked-button class="dropdown-button small-button"
                  (click)="closeSelectDropdown(vadpselect)"
                  [ngClass]="{'dropdown-ok-button': row?.indices?.length > 0 || row?.valueAddedOption?.length > 0 || row?.super_resolution?.length > 0}">
                  <ng-container
                    *ngIf="row?.indices?.length > 0 || row?.valueAddedOption?.length > 0 || row?.super_resolution?.length > 0; else dropDownButton">
                    <span>Ok</span>
                  </ng-container>

                  <ng-template #dropDownButton>
                    <span>Close</span>
                  </ng-template>
                </button>
              </div>
            </mat-option>
          </mat-select>
        </td>
      </ng-container>

      <ng-container matColumnDef="cloudcovers" *ngIf="showColumn && !lbandOnly">
        <th mat-header-cell class="table-header-cell" *matHeaderCellDef style="width: 110px;">
          <span>Cloud Cover <img style="margin-left: 4px; margin-top: -2px" width="14px" src="../../../assets/images/union-white.svg" matTooltip="Amount of accepted cloud cover in a scene" /></span>
        </th>
        <td mat-cell class="cell-Main-Table" *matCellDef="let row; let idx = index"
          style="text-align: left; padding-right: 5px">
          <span
            *ngIf="(row.cloudcovers && row?.rushCloudCover) || (row.key === 'STE' && row?.rushCloudCover && row.sensor != 'SAR')"
            style="width: 80px; padding-left: 1px; font-size: 13px;">
            No Guarantee
          </span>
          <mat-select [disableOptionCentering]="true"
            [panelClass]="row.cloudcovers.length > 5 ? 'matOpenCCsixTable' :row.cloudcovers.length > 4 ? 'matOpenCCfiveTable' : row.cloudcovers.length > 3 ? 'matOpenCCfourTable' : row.cloudcovers.length > 2 ? 'matOpenCCthreeTable' :row.cloudcovers.length > 1 ? 'matOpenCCtwoTable' : 'matOpenCConeTable'"
            *ngIf="(row.cloudcovers && !row?.rushCloudCover)" style="width: 70px;display: block;"
            (selectionChange)="ccChange($event.value, idx, row)"
            placeholder="{{row.selectedCC ? row.selectedCC : row.cloudcovers[0].key}}" [(ngModel)]="row.cloudValue">
            <mat-select-trigger>{{ row.selectedCC }}</mat-select-trigger>
            <mat-option class="triggers" *ngFor="let item of row.cloudcovers; let i = index" [ngValue]="item.key"
              [selected]="row.cloudcover === item.key" [value]="item.key"
              [disabled]="(currentUser.allocated && row.cloudcover !== item.key) || row.prevent || (this.capellaEnable && row.sensor != 'SAR') || (this.satCapeEnable && row.sensor != 'SAR' && row?.key != OPERATOR.SATELLOGIC && row?.key != OPERATOR.STE && row?.key != OPERATOR.USL && row?.key != OPERATOR.BLACKSKY)
            || (row?.key === OPERATOR.BLACKSKY && i < row.cloudcovers.length - 1 && row?.selectedLatencyKey?.key === 'priority')">
              <div class="d-flex justify-content-between">
                <div style=" font-weight: bold">
                  <div class="d-flex justify-content-end">
                    {{ item.key }}
                  </div>
                </div>
                <div style=" text-align: right;">
                  {{ item.value }}x
                </div>
              </div>
            </mat-option>
          </mat-select>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="ONA" *ngIf="!lbandOnly">
        <th mat-header-cell class="table-header-cell" *matHeaderCellDef style="min-width: 215px">
          <span style="min-width: 215px; display: inline-flex; align-items: center; white-space: nowrap;">{{nameONA}} <img style="margin-left: 4px; margin-top: -2px; flex-shrink: 0;" width="14px" src="../../../assets/images/union-white.svg" [matTooltip]="onaTooltip || 'Off-nadir angle / Look angle / Grazing angle'" /></span>
        </th>
        <td mat-cell class="cell-Main-Table" *matCellDef="let row; let idx = index">
          <span style="display: flex;">
            <mat-select [disableOptionCentering]="true"
              [panelClass]="row.ONA.length > 4 ? 'matOpenONAFiveTable' : row.ONA.length > 3 ? 'matOpenONAfourTable' : row.ONA.length > 2 ? 'matOpenONAthreeTable' : row.ONA.length > 1 ? 'matOpenONAtwoTable' : 'matOpenONAoneTable'"
              *ngIf="row.ONA?.length > 0" style="width: 70px" placeholder="{{ row.selectedONA}}"
              (selectionChange)="ONAOption($event.value, idx, row,1)" [(ngModel)]="row.selectedItem"
              [matTooltip]="row?.selectedONA?.length > 7 ? row?.selectedONA : ''">
              <mat-select-trigger [matTooltip]="row?.selectedONA?.length > 5 ? row?.selectedONA : ''">{{ row.selectedONA
                }}</mat-select-trigger>
              <mat-option class="triggers" *ngFor="let item of row.ONA;  let i = index" [ngValue]="item.key"
                [selected]="row.ONA === item.ona || row.ONA === item.key" [value]="item" [disabled]="(currentUser.allocated && row.selectedONA !== item.key) || row.prevent|| (this.capellaEnable && row.sensor != 'SAR') || (this.satCapeEnable && row.sensor != 'SAR' && row?.key != OPERATOR.SATELLOGIC && row?.key != OPERATOR.STE && row?.key != OPERATOR.USL && row?.key != OPERATOR.BLACKSKY) ||
            (row?.key === OPERATOR.UMBRA && item.disabled) || (row?.key === OPERATOR.STE_TELEOS && !item.enabled) || isOperatorOnaDisabled(row, item)">
                <div class="d-flex justify-content-between">
                  <div class="standard" *ngIf="item?.category">
                    {{ item?.category }}
                  </div>
                  <div style=" font-weight: bold; font-size: 14px;">
                    <div class="d-flex justify-content-end">
                      {{ item.ona ? item.ona :item.key }}
                    </div>
                  </div>
                  <div class="name-value">
                    {{ item.onaUplift? item.onaUplift :item.value }}x
                  </div>
                </div>
              </mat-option>
            </mat-select>
            <span *ngIf="isOperatorWithSensor(row)">
              <img style="margin-left: 3px" width="15px" [src]="tooltipImagePath" [matTooltip]="getTooltipText(row)"
                matTooltipPosition="below" />
            </span>
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="advance">
        <th *matHeaderCellDef mat-header-cell>
        </th>
        <td mat-cell *matCellDef="let row; let i = index" style="padding-left: 0px !important; padding-right: 5px">
          <span (click)="OpenAdvance(row,i)" class="normal-cursor"
 *ngIf="((row?.key === OPERATOR.CAPELLA || row?.key === OPERATOR.KOMPSAT || row?.key === OPERATOR.UMBRA || row?.key === OPERATOR.ECURS || row?.key === OPERATOR.ECURS_L || row?.key === OPERATOR.SYNSPECTIVE) && (row?.sensor === 'SAR' || row?.sensor === 'InSAR')) 
        || (row?.key === OPERATOR.KOMPSAT && row?.bitDepth?.length > 0)">
            <img style="margin-top: 3px; width: 18px;" [src]="advanceSettingsImage"
              [matTooltip]="row?.sensor === 'SAR' || row?.sensor === 'InSAR' ? 'Use advanced settings to select polarisation, change angles, and other user-configurable parameters.' : 'Advanced Settings'" />
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="cost">
        <th mat-header-cell class="table-header-cell" *matHeaderCellDef style="text-align: left"
          [hidden]="cpcAndAllocated">
          <span>Unit Cost <img style="margin-left: 4px; margin-top: -2px" width="14px" src="../../../assets/images/union-white.svg" matTooltip="The unit economics of the sensor in sqkm, scene or seconds" /></span>
        </th>
        <td mat-cell class="cell-Main-Table" *matCellDef="let row" style="text-align: left; padding-right: 5px"
          [hidden]="cpcAndAllocated">
          <span style="width: 130px;">
            <span *ngIf="row.enabled && row?.key === OPERATOR.WEATHEREX && !row.unitcost"
              style="color: #888; font-style: italic;">Dynamic Pricing</span>
            <img *ngIf="row.enabled && row?.key === OPERATOR.WEATHEREX && !row.unitcost"
              style="margin-left: 4px; margin-top: -2px" width="14px" [src]="tooltipImagePath"
              matTooltip="The price is generated when you select the sensor." />
            <span *ngIf="row.enabled && !(row?.key === OPERATOR.WEATHEREX && (row.quoteLoading || !row.unitcost))">{{ convertCostToPoints(
              (row?.key === OPERATOR.WEATHEREX || row?.key === OPERATOR.VOYAGERADAR || row?.key === OPERATOR.VESSELFINDER || row?.key === OPERATOR.AISSTREAM) ? row.unitcost
                : row.selectedCost * (row.name === "BRO" && target.subDailyCount > 1 && !isUslBroValidated ? target.subDailyCount : 1),
              true, row) }}/{{
              row.pricingUnit
                  }}</span>
            <!-- Every other sensor here is priced per sqkm, scene or second —
                 units a buyer can compare on sight. "Per credit" cannot be
                 compared until you know what an action costs, so the
                 explanation is offered at the price itself, exactly as the
                 sensor preview offers it. -->
            <mat-icon *ngIf="row.enabled && row?.key === OPERATOR.VOYAGERADAR"
              class="material-icons-outlined credit-info-icon" (click)="openVoyageCreditInfo(row)"
              matTooltip="Credit pricing details" matTooltipPosition="below">
              description
            </mat-icon>
            <mat-icon *ngIf="row.enabled && row?.key === OPERATOR.VESSELFINDER"
              class="material-icons-outlined credit-info-icon" (click)="openVesselFinderCreditInfo(row)"
              matTooltip="Credit pricing details" matTooltipPosition="below">
              description
            </mat-icon>
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="opportunity">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let row; let i = index" style="padding-left: 0px !important; padding-right: 5px">
          <span *ngIf="row?.feasibility">
            <img class="globe" [src]="orbitImage" matTooltip="Opportunity tasking available" />
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="footprint">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let row; let i = index" style="padding-left: 0px !important; padding-right: 5px">
          <span *ngIf="(row?.key === OPERATOR.CAPELLA)" style="text-align: center !important;">
            <mat-icon class="material-icons-outlined map-active" style="cursor: default"
              matTooltip="Scene footprint available">
              map
            </mat-icon>
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

    <ng-container matColumnDef="clientInfo">
      <th mat-header-cell *matHeaderCellDef>
      </th>
      <td mat-cell *matCellDef="let row; let i = index" style="padding-left: 0px !important; padding-right: 5px">
        <span *ngIf="row?.isObfuscated">
          <img class="mask" [src]="maskImage" matTooltip="Obfuscated"/>
        </span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

      <ng-container matColumnDef="eula">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let row; let i = index" style="padding-left: 0px !important; padding-right: 5px">
          <div *ngIf="row?.key !== OPERATOR.VOYAGERADAR && row?.key !== OPERATOR.SENTINEL && row?.key !== OPERATOR.VESSELFINDER" style="text-align: center !important;" class="cs-license-container">
            <span class="cs-eula-badge-wrap" (click)="openEula(target,row)">
              <mat-icon class="material-icons-outlined map-active" style="cursor: pointer"
                matTooltip="End-user license agreement (EULA)">
                handshake
              </mat-icon>
            </span>
            <span *ngIf="row?.key === OPERATOR.UMBRA" class="cs-license-wrap">
              <span class="cc-badge">CC BY 4.0</span>
            </span>
          </div>
          
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="width: 100%; border: none; background: #026fc2"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'highlighted': row.checked && !darkTheme, 'highlighted-dark': row.checked && darkTheme}"
    [hidden]="shouldHideRow(row)"></tr>
    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4" style="color: red">
        No Sensors Selected
      </td>
    </tr>
  </table>
  <div class="no-data" *ngIf="(isAllSensors || isNightSensor || isDailySubdaily || isOpportunitySensors || isObfuscatedSensors) && (dataSource?.data?.length === 0 || dataSource?.data === null)">
        There are no sensors meeting the selection.
  </div>
</div>
</div>

<div *ngIf="selectedSensors.length > 0" class="text mat-footer-cell-Cur">
  <span style="font-weight: normal; padding-right: 10px">Total Selected Sensor<span
      *ngIf=" selectedSensors.length > 1">s</span>: </span>{{ selectedSensors.length }}
</div>
<div *ngIf="(target?.taskStrategy === 'Tip-and-Cue' && selectedSensors.length >= 2)">
  <div class="profile-btn">
    <button class="custom-button" type="reset" (click)="clearSensorCostDetails()">Cancel</button>
    <button mat-flat-button color="primary" color="primary" type="submit" (click)="submit(false)"
      [disabled]="enable || demoView">
      Submit
    </button>
  </div>
</div>
<div
  *ngIf="(target?.taskStrategy !== 'Tip-and-Cue' && selectedSensors.length > 0 && target?.taskStrategy !== 'AIS Included')  || (selectedSensors.length > 1 && target?.taskStrategy === 'AIS Included' && isAISSensor) || (selectedSensors.length > 0 && target?.taskStrategy === 'AIS Included' && !isAISSensor)">
  <div class="submitbtn">
    <button mat-flat-button color="primary" type="submit" (click)="submit(true)"
      [disabled]="isTipAndCue || enable || demoView || checkFeasible() || feasibleAIS()" class="taskSubmit"
      matTooltip="Please use this only when you need a specific satellite pass or collection time. If a capture fails, no re-attempt is made.">
      Opportunity tasking
    </button>
  </div>
  <div class="oprtybtn">
    <button mat-flat-button color="primary" type="submit" (click)="submit(false)" [disabled]="enable || demoView"
      class="submitAuto">
      Automated tasking
    </button>
  </div>
</div>

<mat-menu #tooltipMenu="matMenu" class="band-menu-style" xPosition="after" yPosition="above" (closed)="onMenuClosed()">
  <app-custom-tooltip [metadata]="bandInfoTooltip" product="band" [operator]="selectedOperator"></app-custom-tooltip>
</mat-menu>

<mat-menu #tooltipFeed="matMenu" class="band-menu-style" xPosition="after" yPosition="above" (closed)="onMenuClosed()">
  <app-custom-tooltip [metadata]="feedInfoTooltip" product="feed" [operator]="selectedOperator"></app-custom-tooltip>
</mat-menu>
